export enum ScreenSize {
  Unknown,
  Mobile,
  Tablet,
  Desktop,
}

//the size of the display width, which determines the design for mobile and desktop devices
export const widthBreakpoint = 959
